import './modal-campaign.scss';
import { useState, useEffect } from 'react';
import ModalTemplate from '../modal-template/modal-template';
import ICON_MEDAL from '../../assets/icon-medal-campaign.png';
import Button from '../button/button';
import TranslateService from '../../services/translate-service';

export default function ModalCampaignStatus(props) {

    const [activeIndex, setActiveIndex] = useState(0);

    const prev = () => {
        setActiveIndex(activeIndex - 1)
    }

    const next = () => {
        if(activeIndex === 2 ) {
            props.onClose();
        } else {
            setActiveIndex(activeIndex + 1)
        }
    }


    useEffect(() => {
        if (props.isOpen) {
            setActiveIndex(0)
        }

    }, [props.isOpen])

    return (
        <ModalTemplate isOpen={props.isOpen} className='modal-campaign '>
            <div className='text-center'>
                <h1 className='heading-h6 !text-white'>{TranslateService.get('campaign.modal.new.title')}</h1>
                <img src={ICON_MEDAL} alt='' className='mx-auto mt-[32px]' />

                <div className='overflow-hidden '>

                    <div className='inner'  style={{ transform: `translateX(-${activeIndex * 100}%)` }}>
                        <div className='inline-block min-w-full whitespace-normal px-[32px]'>
                            <h1 className='heading-h5 mt-[24px]'>{props.campaign?.nombre}</h1>
                            <p className='mt-[8px]'>{TranslateService.get('campaign.modal.new.1.subtitle')}</p>

                            <div className='py-[16px] px-[48px] bg-[#FFFBEF] text-[#675515] mt-[24px]'>
                                <p>{TranslateService.get('campaign.modal.new.1.description')}</p>
                            </div>
                        </div>
                        <div className='inline-block min-w-full whitespace-normal px-[32px]'>
                            <h1 className='heading-h5 mt-[24px]'>{TranslateService.get('campaign.modal.new.2.subtitle')}</h1>
                            <p className='mt-[8px]'>{TranslateService.get('campaign.modal.new.2.description')}</p>
                        </div>
                        <div className='inline-block min-w-full whitespace-normal px-[32px]'>
                            <h1 className='heading-h5 mt-[24px]'>{TranslateService.get('campaign.modal.new.3.subtitle')}</h1>
                            <p className='mt-[8px]'>{TranslateService.get('campaign.modal.new.3.description')}</p>
                        </div>
                    </div>

                </div>

                <div className={ 'mt-[28px] flex justify-end ' + (activeIndex === 1 ? ' justify-between ': ' ' ) + (activeIndex === 2 ? ' justify-center ': '' ) }>
                    {activeIndex > 0 && activeIndex < 2 && <Button className='link' onClick={prev}>{TranslateService.get('campaign.modal.new.previous')}</Button>}
                    
                    <Button className='small' onClick={next}>
                        {/* { activeIndex === 2 ? 'START CAMPAIGN' : 'CONTINUE'} */}
                        {TranslateService.get('campaign.modal.new.next')}
                    </Button>
                </div>


            </div>
        </ModalTemplate>
    )
}